import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import LandingPage from './landing/LandingPage'
import PricingPage from './landing/PricingPage'
import PrivacyPolicyPage from './landing/PrivacyPolicyPage'
import TermsOfServicePage from './landing/TermsOfServicePage'
import ScrollToTop from './ui/ScrollToTop'

/**
 * UnauthenticatedApp handles all routing for non-logged-in users.
 * Each page can have its own route and be directly linkable.
 */
export default function UnauthenticatedApp() {

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        {/* Redirect any unknown routes to landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  )
}

